(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('Password', Password);

  Password.$inject = ['$resource', 'API_URI'];

  function Password($resource, API_URI) {
    return $resource(API_URI + 'api/account/change_password', {}, {});
  }
})();
